module.exports = __webpack_public_path__ + "media/images/favicons/favicon-wednesday-32x32-73fc4e3f4397b46fc2859a5a416e3990.png";